import { uniqueId as uId } from 'lodash-es';
const getLabelId = prefix => uId(`${prefix || 'urc-label'}-`);
const lengthHelp = max => (value = '') => {
  // Remove special characters from remaining analysis
  const digits = max - value.replaceAll(/[()\-\s]/g, '').length;
  if (digits > 0) return `${digits} remaining digits.`;
  return `none remaining digits to type.`;
};

// eslint-disable-next-line import/prefer-default-export
export { getLabelId, lengthHelp };
//# sourceMappingURL=aria.js.map